import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Page404 from "./views/Page404";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import Login from "./views/Login/Login";
import LoginAlternative from "./views/Login/LoginAlternative";
import Logout from "./views/Logout";
import Register from "./views/Register";
import EcrfForm from "features/ecrf/views/EcrfForm/EcrfForm";
import PrivateRoute from "commons/router/PrivateRoute";
import { roles } from "commons/auth/roles";
import {
  ROUTES_CORE,
  ROUTES_ECRF,
  ROUTES_DRUG,
  ROUTES_USERS,
  ROUTES_MEDICAL_CENTERS,
  ROUTES_DASHBOARD,
  ROUTES_DOCUMENTATION_MANAGEMENT,
  ROUTES_DRUG_MANAGEMENT,
} from "commons/constants/paths";
import HomeAida from "./views/Home/Aida";
import HomeDefault from "./views/Home/Default";
import HomeEmpathy from "./views/Home/Empathy";
import HomeIdole from "./views/Home/Idole";
import HomeImprove from "./views/Home/Improve";
import HomeJasnum from "./views/Home/Jasnum";
import HomeRefsal from "./views/Home/Refsal";
import HomeSapho from "./views/Home/Sapho";
import Dashboard from "features/dashboard/views/Dashboard";
import UsersList from "features/users/views/UsersList";
import UserAdd from "features/users/views/UserAdd";
import UserEdit from "features/users/views/UserEdit";
import MedicalCentersList from "features/medicalCenters/views/MedicalCentersList";
import MedicalCenterEdit from "features/medicalCenters/views/MedicalCenterEdit";
import MedicalCenterAdd from "features/medicalCenters/views/MedicalCenterAdd";
import DrugEdit from "features/drugs/views/DrugEdit";
import DrugAdd from "features/drugs/views/DrugAdd";
import DrugsList from "features/drugs/views/DrugsList";
import Documentation from "features/documentation-management/views/Documentation";
import DrugsManagementSwitcher from "features/drugs-management/views/DrugsManagementSwitcher";
import { RESEARCH } from "commons/constants/env";

const renderHomePage = () => {
  switch (RESEARCH) {
    case 'AIDA': return <HomeAida />;
    case 'EMPATHY': return <HomeEmpathy />;
    case 'IDOLE': return <HomeIdole />;
    case 'IMPROVE': return <HomeImprove />;
    case 'JASNUM': return <HomeJasnum />;
    case 'REFSAL': return <HomeRefsal />;
    case 'SAPHO': return <HomeSapho />;
    default: return <HomeDefault />;
  }
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { path: ROUTES_CORE.HOME, element: renderHomePage() },
      { path: ROUTES_CORE.FORGOT_PASSWORD, element: <ForgotPassword /> },
      { path: ROUTES_CORE.RESET_PASSWORD(':token'), element: <ResetPassword /> },
      { path: ROUTES_CORE.LOGIN, element: <Login /> },
      { path: ROUTES_CORE.LOGIN_ALTERNATIVE, element: <LoginAlternative /> },
      { path: ROUTES_CORE.LOGOUT, element: <Logout /> },
      { path: ROUTES_CORE.REGISTER, element: <Register /> },

      { path: ROUTES_ECRF.DETAILS(':id'), element: <PrivateRoute roles={[...roles.admin, ...roles.research]}><EcrfForm /></PrivateRoute> },
      { path: ROUTES_ECRF.DETAILS_EXTENDED(':id', ':section'), element: <PrivateRoute roles={[...roles.admin, ...roles.research]}><EcrfForm /></PrivateRoute> },
      { path: ROUTES_ECRF.DETAILS_FULL_EXTENDED(':id', ':section', ':element'), element: <PrivateRoute roles={[...roles.admin, ...roles.research]}><EcrfForm /></PrivateRoute> },

      { path: ROUTES_DRUG.ADD, element: <PrivateRoute roles={roles.admin}><DrugAdd /></PrivateRoute> },
      { path: ROUTES_DRUG.EDIT(':id'), element: <PrivateRoute roles={roles.admin}><DrugEdit /></PrivateRoute> },
      { path: ROUTES_DRUG.LIST, element: <PrivateRoute roles={roles.admin}><DrugsList /></PrivateRoute> },

      { path: ROUTES_MEDICAL_CENTERS.ADD, element: <PrivateRoute roles={roles.admin}><MedicalCenterAdd /></PrivateRoute> },
      { path: ROUTES_MEDICAL_CENTERS.EDIT(':id'), element: <PrivateRoute roles={roles.admin}><MedicalCenterEdit /></PrivateRoute> },
      { path: ROUTES_MEDICAL_CENTERS.LIST, element: <PrivateRoute roles={roles.admin}><MedicalCentersList /></PrivateRoute> },

      { path: ROUTES_USERS.ADD, element: <PrivateRoute roles={roles.admin}><UserAdd /></PrivateRoute> },
      { path: ROUTES_USERS.EDIT(':id'), element: <PrivateRoute roles={roles.admin}><UserEdit /></PrivateRoute> },
      { path: ROUTES_USERS.LIST, element: <PrivateRoute roles={roles.admin}><UsersList /></PrivateRoute> },

      { path: ROUTES_DASHBOARD.DETAILS(':type'), element: <PrivateRoute roles={roles.all}><Dashboard /></PrivateRoute> },
      { path: ROUTES_DASHBOARD.DASHBOARD, element: <PrivateRoute roles={roles.all}><Dashboard /></PrivateRoute> },

      { path: ROUTES_DOCUMENTATION_MANAGEMENT.MODULE, element: <PrivateRoute roles={roles.all}><Documentation /></PrivateRoute> },
      { path: ROUTES_DRUG_MANAGEMENT.MODULE, element: <PrivateRoute roles={[...roles.admin, ...roles.control]}><DrugsManagementSwitcher /></PrivateRoute> },

      { path: '*', element: <Page404 /> },
    ],
  },
]);

export default router;